import { Button, message, Modal } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { saveAs } from "file-saver";
import json2csv from "json2csv";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router";
import { ClipLoader, ScaleLoader } from "react-spinners";
import { usersList } from "../../actions/employees/employees";
import { apis } from "../../config/APIs";
import endpoint from "../../config/Axios";
import useAxios from "../../config/useAxios";
import { hasAccess } from "../../utils";
import Table from "../Common/Table/Table";
import PageHeader from "../PageHeader";
import Loader from "../Loader";

const UserDashboard = () => {
  const dispatch = useDispatch();
  const {
    onCall: onCallApprove,
    data: approveData,
    reset: approveReset,
    loading: approveLoading,
  } = useAxios({ api: "/api/staff/users/v1/approve", method: "post" });
  const {
    onCall: onCallReject,
    data: rejectData,
    reset: rejectReset,
    loading: rejectLoading,
  } = useAxios({ api: "/api/staff/users/v1/reject", method: "post" });

  const loginRole = sessionStorage.getItem("role");
  const users_list = useSelector((state) => state?.users?.list);
  const users_list_export = useSelector((state) => state?.users?.export);
  const [filters, setFilters] = React.useState({});
  const [isQuick, setIsQuick] = useState(true);
  const [expLoading, setExpLoading] = React.useState(false);
  const [isAccept, setIsAccept] = useState(false);
  const [userData, setUserData] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isReject, setIsReject] = useState(false);
  const [reasonValue, setReasonValue] = useState("");
  const [isApprove, setIsApprove] = useState(false);
  const [page, setPage] = useState(1);

  const userLoader = useSelector((state) => state?.users?.list?.loading);
  React.useEffect(() => {
    dispatch(usersList({ page: 1, per: 50 }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  React.useEffect(() => {
    if (users_list_export?.success) {
      window.open(users_list_export?.data?.response["CSV File URL"], "_blank");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [users_list_export]);

  useEffect(() => {
    if (rejectData?.status || approveData?.status) {
      message.success(
        <span className="messageText">
          {rejectData?.message ? rejectData?.message : approveData?.message}
        </span>,
      );
      approveReset();
      rejectReset();
      setSelectedRowKeys([]);
      dispatch(usersList({ page: 1, per: 50 }));
      setIsReject(false);
      setIsAccept(false);
      setIsApprove(false);
    } else if (rejectData?.errors || approveData?.errors) {
      message.error(
        <span className="messageText">
          {rejectData?.message ? rejectData?.message : approveData?.message}
        </span>,
      );
      approveReset();
      rejectReset();
    }
  }, [rejectData, approveData]);
  const handleSearch = (value) => {
    dispatch(usersList({ ...filters, page: 1, search: value, per: 50 }));
    setFilters({
      ...filters,
      search: value,
      page: 1,
      per: 50,
    });
    setPage(1);
  };

  const handleRowClick = (event, record) => {
    setIsAccept(true);
    setUserData(record);
  };

  const columns = [
    // {
    //   title: "S.NO",
    //   dataIndex: "id",
    //   key: "id",
    //   // render: (text, data, idx) => {
    //   //   return <div className={`status-line`}>{idx + 1}</div>;
    //   // },
    //   render: (text, data, idx) => {
    //     return <div>{idx + 1}</div>;
    //   },
    // },
    {
      title: "Company Name",
      dataIndex: "company",
      key: "company",
      className: "user-col",
    },
    {
      title: "Employee Name",
      dataIndex: "name",
      key: "name",
      className: "user-col",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      className: "user-col",
    },
    {
      title: "Mobile",
      dataIndex: "primary_phone",
      key: "primary_phone",
      className: "user-col",
    },
    // {
    //   title: "Client",
    //   dataIndex: "client",
    //   className: "user-col",
    //   key: "client",
    // },
    {
      title: "Created Date",
      dataIndex: "created_date",
      key: "created_date",
      className: "user-col",
      render: (text) => (
        <div>{moment(text, "DD-MM-YYYY, HH:mm:ss").format("DD-MM-YYYY, HH:mm:ss")}</div>
      )
    },
    {
      title: "Last Login",
      dataIndex: "last_login",
      className: "user-col",
      key: "last_login",
      render: (text) => (
        <div>
          {text
            ? moment(text, "DD-MM-YYYY, HH:mm:ss").format("DD-MM-YYYY, HH:mm:ss")
            : "-"}
        </div>
      )
    },
    {
      title: "Role",
      dataIndex: "role",
      className: "user-col",
      key: "role",
      render: (text) => <div>{text ? text?.join(", ") : "-"}</div>,
    },
    {
      title: "Status",
      dataIndex: "status",
      className: "user-col",
      key: "status",
      render: (text) => (
        <div className={`status status_${text}`}>
          {text
            .replace(/_/g, " ")
            .toLowerCase()
            .replace(/^\w/, (c) => c.toUpperCase())}
        </div>
      ),
    },
  ];

  const originalFilters = useMemo(() => {
    return [
      {
        label: "Status",
        action: (value) => {
          const newStatus = value === "all" ? "" : value;

          setFilters((prevFilters) => {
            const updatedFilters = {
              ...prevFilters,
              page: 1,
              status: newStatus,
              per: 50,
            };
            dispatch(
              usersList({
                ...updatedFilters,
              }),
            );
            return updatedFilters;
          });
        },
        type: "dropdown",
        options: [
          { label: "All", value: "all" },
          { label: "Active", value: "active" },
          { label: "Pending Approval", value: "pending_approval" },
          { label: "Rejected", value: "rejected" },
        ],
        value: filters.status || null,
      },
    ];
  }, [filters]);

  const [topFilters, setTopFilters] = useState(originalFilters);

  useEffect(() => {
    if (sessionStorage.getItem("is_corporate_checker")?.includes("true")) {
      setTopFilters(
        originalFilters.filter((filter) => filter.label !== "Status"),
      );
    } else {
      setTopFilters(originalFilters);
    }
  }, [loginRole]);

  const staffUserData = useMemo(() => {
    return [
      {
        label: "Company Name",
        value: userData?.company,
      },
      {
        label: "Employee Name",
        value: userData?.name,
      },
      {
        label: "Email",
        value: userData?.email,
      },
      {
        label: "Date of Birth",
        value: userData?.dob,
      },
      {
        label: "Mobile",
        value: userData?.primary_phone,
      },
      {
        label: "Role",
        value: userData?.role?.join(", "),
      },
      {
        label: "Employee ID",
        value: userData?.employee_id?.join(", "), // Assuming employee_id is an array
      },
      {
        label: "Status",
        value: (
          <div
            className={`status status_${userData?.status
              ?.toLowerCase()
              .replace(/ /g, "_")}`}
          >
            {(userData?.status || "-")
              .replace(/_/g, " ")
              .toLowerCase()
              .replace(/^\w/, (c) => c.toUpperCase())}
          </div>
        ),
      },

      {
        label: "Created Date",
        value: moment(userData?.created_date, "DD-MM-YYYY, HH:mm:ss").format(
          "DD-MM-YYYY, HH:mm:ss"
        ),
      },

      {
        label: "Address Line 1",
        value: userData?.address_line_1,
      },
      {
        label: "Address Line 2",
        value: userData?.address_line_2,
      },
      {
        label: "Address Line 3",
        value: userData?.address_line_3,
      },
      {
        label: "City",
        value: userData?.city,
      },
      {
        label: "Pincode",
        value: userData?.pincode,
      },
      {
        label: "State",
        value: userData?.state,
      },
      {
        label: "Communication Address Line 1",
        value: userData?.communication_address_line_1,
      },
      {
        label: "Communication Address Line 2",
        value: userData?.communication_address_line_2,
      },
      {
        label: "Communication Address Line 3",
        value: userData?.communication_address_line_3,
      },
      { label: "Communication City", value: userData?.communication_city },
      {
        label: "Communication Pincode",
        value: userData?.communication_pincode,
      },
      { label: "Communication State", value: userData?.communication_state },
      // {
      //   label: "Annual Income",
      //   value: `${userData?.annual_income ?? 0}`,
      // },
      // {
      //   label: "Source Income Type",
      //   value: userData?.source_income_type,
      // },
      // {
      //   label: "Source of Income",
      //   value: userData?.source_of_income,
      // },
      {
        label: "Occupation",
        value: userData?.occupation,
      },
      {
        label: "Nationality",
        value: userData?.nationality,
      },
      // {
      //   label: "Political Exposed Person",
      //   value: userData?.political_exposed_person,
      // },
      // {
      //   label: "Fatca Declaration",
      //   value: userData?.fatca_declaration,
      // },
      // {
      //   label: "PAN",
      //   value: userData?.pan,
      // },
      { label: "KYC Type", value: userData?.kyc_type },
      { label: "KYC Method", value: userData?.kyc_method },
      {
        label: "OVD Type",
        value: userData?.ovd_type,
      },
      { label: "OVD Details", value: userData?.ovd_details },
      {
        label: "Customer Type",
        value: userData?.customer_type,
      },
      {
        label: "Gender",
        value: userData?.gender,
      },
    ];
  }, [userData]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleReject = () => {
    setIsReject(true);
    setReasonValue("");
  };
  const handleApprove = () => {
    setIsApprove(true);
  };

  const handlePaginationChange = useCallback(
    (page) => {
      dispatch(
        usersList({
          ...filters,
          page,
          per: 50,
        }),
      );
      setPage(page);
      setFilters({
        ...filters,
        page,
      });
      // eslint-disable-next-line
    },
    [filters, dispatch],
  );

  return (
    <>
      {userLoader && <Loader />}

      {isApprove && (
        <Modal
          open={isApprove}
          title="Approve User"
          footer={[]}
          onCancel={() => {
            setIsApprove(false);
          }}
        >
          Are you sure you want to approve this user?
          <div className="d-flex">
            <Button
              key="1"
              htmlType="submit"
              className="formButton mt1"
              onClick={() => {
                if (selectedRowKeys?.length > 0) {
                  onCallApprove({
                    data: {
                      user_ids: [...selectedRowKeys],
                    },
                    params: {
                      bulk: true,
                    },
                  });
                } else {
                  onCallApprove({
                    data: {
                      user_id: userData?.id,
                    },
                  });
                }
              }}
            >
              {approveLoading ? (
                <ClipLoader loading={approveLoading} size={20} color="#FFF" />
              ) : (
                "Confirm"
              )}
            </Button>
            <Button
              key="2"
              className="cancelButton ml1 mt1"
              onClick={() => {
                setIsApprove(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </Modal>
      )}

      {isReject && (
        <Modal
          title="Enter Reject Reason"
          open={isReject}
          footer={[]}
          onCancel={() => {
            setIsReject(false);
          }}
        >
          <div>
            <TextArea
              rows={5}
              placeholder="Enter Reason"
              onChange={(e) => {
                setReasonValue(e?.target?.value);
              }}
            ></TextArea>
          </div>

          {userData?.status == "active" ||
          userData?.status == "rejected" ||
          !sessionStorage
            .getItem("is_corporate_checker")
            ?.includes("true") ? null : (
            <div className="d-flex">
              <Button
                key="1"
                className="cancelButton ml1 mt1"
                onClick={() => {
                  setIsReject(false);
                }}
              >
                Cancel
              </Button>
              <Button
                key="2"
                className="formButton mt1 ml1"
                onClick={() => {
                  if (selectedRowKeys?.length > 0) {
                    onCallReject({
                      data: {
                        user_ids: [...selectedRowKeys],
                        reject_reason: reasonValue,
                      },
                      params: {
                        bulk: true,
                      },
                    });
                  } else {
                    onCallReject({
                      data: {
                        user_id: userData?.id,
                        reject_reason: reasonValue,
                      },
                    });
                  }
                }}
                disabled={!reasonValue?.trim()}
              >
                {rejectLoading ? (
                  <ClipLoader loading={rejectLoading} size={20} color="#FFF" />
                ) : (
                  "Confirm"
                )}
              </Button>
            </div>
          )}
        </Modal>
      )}

      {isAccept && (
        <Modal
          title="User Details"
          open={isAccept}
          footer={[]}
          onCancel={() => {
            setIsAccept(false);
          }}
          className="right-alinged-modal width-value"
        >
          {userData?.status === "rejected" ? (
            <div className="item-details p1 mt2">
              <div className="item-detail">
                <label>Reason for Rejection</label>
                <p title={userData?.reject_reason}>
                  {userData?.reject_reason ? userData?.reject_reason : "-"}
                </p>
              </div>
            </div>
          ) : null}
          <div className="item-details p1 mt2">
            {staffUserData?.map((listElement, listIndex) => (
              <div className="item-detail" key={listIndex}>
                <label>{listElement?.label}</label>
                <p title={listElement?.value}>
                  {listElement?.value ? listElement?.value : "-"}
                </p>
              </div>
            ))}
          </div>
          {userData?.status == "active" ||
          userData?.status == "rejected" ||
          !sessionStorage.getItem("is_corporate_checker")?.includes("true") ||
          !hasAccess("cc_user_approvals", "write") ? null : (
            <div className="d-flex">
              <Button
                key="1"
                className="formButton ml1 mt1"
                onClick={() => {
                  setIsApprove(true);
                }}
              >
                Approve
              </Button> 
              <Button
                key="2"
                className="cancelButton mt1 ml1"
                onClick={() => {
                  setIsReject(true);
                }}
              >
                Reject
              </Button>
            </div>
          )}
        </Modal>
      )}

      <div className="heading-div">
        <PageHeader title={`Users`} />
      </div>
      <Table
        columns={columns}
        placeholder={"Search by Employee Name, Mobile, Email"}
        data={users_list?.data?.response?.users}
        isTopFilter={true}
        filter={true}
        handleSearch={handleSearch}
        topFilters={topFilters}
        pagination={{
          showTotal: (total, range) => {
            return `Showing ${range[0]} to ${range[1]} of ${total} entries`;
          },
          pageSize: 50,
          current: page,
          total: users_list?.data?.total_records || 0,
          activePage: filters.page,
          onChange: handlePaginationChange,
        }}
        btnsComponent={
          // <>
          //   <button className={isQuick ? "primary-btn" : "nm-btn"}>
          //     Users
          //   </button>
          //   <button className={`mr1 ${!isQuick ? "primary-btn" : "nm-btn"}`}>
          //     Bulk Users
          //   </button>
          // </>
          null
        }
        exportLoading={expLoading}
        exportToExcel={() => {
          setExpLoading(true);

          endpoint
            .get(
              apis.usersList,
              {
                params: {
                  ...filters,
                  csv: true,
                },
              },
              { skipSuccessMessage: true }
            )
            .then((res) => {
              setExpLoading(false);

              let usrs = res?.data?.response?.users;

              let csv = json2csv.parse(
                usrs?.map((ele) => ({
                  "Company Name": ele.company,
                  "Employee Name": ele.name,

                  "Title": ele.title,
                  "First Name": ele.first_name,
                  "Last Name": ele.last_name,

                  "Email": ele.email,
                  "Mobile": ele.primary_phone,

                  "Date of Birth": ele.dob,

                  "Role": Array.isArray(ele.role)
                    ? ele.role.join(", ")
                    : ele.role,

                  "Employee ID": Array.isArray(ele.employee_id)
                    ? ele.employee_id.join(", ")
                    : ele.employee_id,

                  "Gender": ele.gender,
                  "Nationality": ele.nationality,
                  "Occupation": ele.occupation,

                  "Address Line 1": ele.address_line_1,
                  "Address Line 2": ele.address_line_2,
                  "Address Line 3": ele.address_line_3,

                  "City": ele.city,
                  "Pincode": ele.pincode,
                  "State": ele.state,

                  "Communication Address Line 1": ele.communication_address_line_1,
                  "Communication Address Line 2": ele.communication_address_line_2,
                  "Communication Address Line 3": ele.communication_address_line_3,

                  "Communication City": ele.communication_city,
                  "Communication Pincode": ele.communication_pincode,
                  "Communication State": ele.communication_state,

                  "KYC Type": ele.kyc_type,
                  "KYC Method": ele.kyc_method,
                  "OVD Type": ele.ovd_type,
                  "OVD Details": ele.ovd_details,
                }))
              );

              const blob = new Blob([csv], {
                type: "text/csv;charset=utf-8",
              });

              saveAs(blob, "users.csv");
            })
            .catch(() => {
              setExpLoading(false);
            });
        }}
        handleRowClick={handleRowClick}
        rowSelection={rowSelection}
        selectedRows={selectedRowKeys}
        rejectClick={handleReject}
        approveClick={handleApprove}
        approveLoading={approveLoading}
        rejectLoading={rejectLoading}
        rowClassName={"user-dashboard"}
        isMore={true}
        isHeaderButton={hasAccess("cc_user_approvals", "write")}
      />
    </>
  );
};

export default withRouter(UserDashboard);
